// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602261233/js/" + chunkId + "." + {"44":"8115843a","225":"bb40b0a8","481":"b28922c8","486":"e24e4346","770":"9867a1f8"}[chunkId] + ".0.14801167590641584.chunk.js";
};